import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
//import {fetchPOST} from '../../helpers/sharedFetch.js'
import {useLogin} from '../../helpers/loginContext.js';
import fetchPOST from '../../helpers/sharedFetch.js'
import ConfirmEmailCode from '../ConfirmEmailCode/index.js'
import VisiblePassword from '../../components/visiblePassword.js'
import SuccessfullAccountCreation from '../../components/successfullAccountCreation.js'

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiResult} from '../../../../server/routes/user.js'

// Interface for component props
interface ResetPasswordProps {
    onSuccess?: () => void;
}

export default function ResetPassword(onSuccess?: ResetPasswordProps) {

    const initialFlashProps: FlashMessageData = {};
    const {setLoginType} = useLogin();
    const [showSuccessfullAccountCreation, setShowSuccessfullAccountCreation] = useState<boolean>(false);
    const [showEnterEmailCode, setShowEnterEmailCode] = useState<boolean>(false);
    const [showSetPassword, setShowSetPassword] = useState<boolean>(false);
    const [flashProps, setFlashProps] = useState(initialFlashProps);

    function handleEmailCodeConfirmed(otpCode: string) {

        setFlashProps({});

        fetchPOST(
            "/user/password-reset-confirm-otp", 
            {
                otpCode: otpCode
            },
            {
                onSuccess: (untypedResponse: unknown) => {
                    const response = untypedResponse as APIResponse<RtApiResult>
                    setShowEnterEmailCode(false);
                    setShowSetPassword(true);
                    setFlashProps(response.results!);
                    console.log(` fetch success`)

                },
                onError: (error: string) => {
                    console.log(` fetch failed: ${error}`)
                    setFlashProps({error: error});
                }
            }
        )        
    }
    function handleResetPasswordSubmit(email: string, captcha: string) {
    
        setFlashProps({});
    
        console.log(`before fetch`)

        fetchPOST(
            "/user/reset-password", 
            {
                email,
                captcha,
            },
            {
                onSuccess: (untypedResponse: unknown) => {
                    const response = untypedResponse as APIResponse<RtApiResult>
                    setFlashProps(response.results!);
                    setShowEnterEmailCode(true);

                },
                onError: (error: string) => {
                    console.log(` fetch failed: ${error}`)
                    setFlashProps({error: error});
                }
            }
        )
    }
    function handleSetPassword(password: string) {
    
        setFlashProps({});

        fetchPOST(
            "/user/set-password", 
            {
                password: password
            },
            {
                onSuccess: (response: unknown) => {
                    console.log(`setpassword fetch success`)
                    setShowSuccessfullAccountCreation(true);
                },
                onError: (error: string) => {
                    console.log(`setpassword fetch failed: ${error}`)
                    setFlashProps({error: error});
                }
            }
        )        
    }

    const formToShow = (()=>{
        if (showSetPassword) {
            return (<SetPasswordForm onSetPassword={handleSetPassword}/>)
        }
        else if (showEnterEmailCode) {
            return (<ConfirmEmailCode onConfirmCode={handleEmailCodeConfirmed}/>)
        }
        else {
            return <ResetPasswordForm onSubmit={handleResetPasswordSubmit}/>
        }
    })();


    if (showSuccessfullAccountCreation) {
        return (<SuccessfullAccountCreation message='You have successfully set a new password. This page will refresh in a few seconds'/>)
    }

	return (
    <>
    
    {/* <div className="container">
        <div className="row mt-5">
            <div className="col-md-5 m-auto">
                <div className="card card-body"> */}
                    <h4 className="text-center mb-3">
                        <b>
                            Reset Password
                        </b>
                    </h4>
                    <div className="form-group">
                            <FlashMessages props={flashProps} />
                    </div>
                    {formToShow}
                {/* </div>
            </div>
        </div> 
    </div>*/}
</>)

}

// Interface for ResetPasswordForm props
interface ResetPasswordFormProps {
    onSubmit: (email: string, captcha: string) => void;
}

function ResetPasswordForm({onSubmit}: ResetPasswordFormProps) {

    const recaptchaRef = React.createRef<ReCAPTCHA>();

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
    
        const form = event.currentTarget;
        const emailElement = form.elements.namedItem('email') as HTMLInputElement;
        const captcha = recaptchaRef.current?.getValue() || '';

        // call parent
        onSubmit(emailElement.value, captcha);
    }
    
    return (                    
    <form action="/user/reset-password" onSubmit={handleSubmit}>
        <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Enter Email"
            />
        </div>
        {/* sitekey={data.ReCaptchaSiteKey} */}
        <div className="form-group">
            <ReCAPTCHA 
                ref={recaptchaRef}
                sitekey={window.wts_captcha_public_key!}
            />
        </div>
        <button type="submit" className="btn btn-primary btn-block">
            Reset Password
        </button>
    </form>
    )
}


// Interface for SetPasswordForm props
interface SetPasswordFormProps {
    onSetPassword: (password: string) => void;
}

function SetPasswordForm({onSetPassword}: SetPasswordFormProps) {

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    
        event.preventDefault();
    
        const form = event.currentTarget;
        const passwordElement = form.elements.namedItem('password') as HTMLInputElement;

        onSetPassword(passwordElement.value);
    }
    
    return (<>
        <form action="/user/set-password" onSubmit={handleSubmit}>
            <div className="form-group">
                <VisiblePassword id={"password"} />
            </div>
            <button type="submit" className="btn btn-primary btn-block">
                Set Password
            </button>
        </form>
    </>)

}


/*
    // TODO: refacto this. At least 3 places has this
    if (successRegisterMessage && successRegisterMessage.length) {
        return (
            <>
                <div className="container">
                    <div className="row mt-5">
                        <div className="col-md-5 m-auto">
                            <div className="card card-body">
                                <div>
                                    <div className="alert alert-success" role="alert">
                                        {successRegisterMessage}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

*/